import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import JoditEditor from "jodit-react";
import classNames from "classnames";
import { IDS, Website_Type } from "../../../utils/common";
import Select from "react-select";

library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, Select2Data } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const {
    control,
    register,
    handleSubmit,
    setValue,
    trigger,
    watch,
    formState: { errors },
    reset,
    getValues,
  } = useForm();
  const imageFile = watch("image");
  
  const GetEditData = async () => {
    const response = await getData(`/masters/gift-occassion/${id}`);
    const editData = response?.data;

    const selectedProducts =
      editData?.gift_occassion_multiples
        ?.filter((i) => i.product_id)
        ?.map((i) => ({
          label: i?.product?.name,
          value: i?.product_id,
        })) || [];

    reset({
      name: editData.name,
      sub_name: editData.sub_name,
      product_ids: selectedProducts,
    });
    setImagePreview(IMG_URL + editData.image);
  };

  useEffect(() => {
    if (id) {
      GetEditData();
    }
  }, [id]);

  const onSubmit = async (data) => {
  try {
    const sendData = new FormData();

    sendData.append("name", data.name);
    sendData.append("sub_name", data.sub_name);

    if (data.image?.[0]) {
      sendData.append("image", data.image[0]);
    }

    if (data.product_ids) {
      sendData.append(
        "product_ids",
        JSON.stringify(data.product_ids.map((option) => option.value))
      );
    }

    const response = await postData(
      `/masters/gift-occassion/${id}`,
      sendData
    );

    setShowModal({
      code: response.code,
      message: response.message,
    });

    setTimeout(() => {
      setShowModal(0);
      props.handleClose();
    }, 1000);
  } catch (error) {
    console.log(error);
  }
};

  const GetAllProduct = async () => {
    const response = await getData(`/all-products/${Website_Type?.Luxury}`);

    if (response?.success) {
      setProducts(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Home Occassion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="text-center">
                      <Form.Label>Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="text-center">
                      <Form.Label>Sub Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="sub_name"
                        placeholder="Sub Name"
                        className={classNames("", {
                          "is-invalid": errors?.sub_name,
                        })}
                        {...register("sub_name", {
                          required: "Sub Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.sub_name && (
                      <span className="text-danger">
                        {errors.sub_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="text-center">
                      <Form.Label>Image</Form.Label>
                    </div>
                    <Form.Group>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        {...register("image", {
                          // validate: (value) => {
                          //   // if no new image selected → OK
                          //   if (!value || value.length === 0) return true;
                          //   const file = value[0];
                          //   const allowedTypes = [
                          //     "image/jpeg",
                          //     "image/png",
                          //     "image/jpg",
                          //   ];
                          //   if (!allowedTypes.includes(file.type)) {
                          //     return "Only JPG, JPEG, PNG allowed";
                          //   }
                          //   if (file.size > 500 * 1024) {
                          //     return "File size must be under 500KB";
                          //   }
                          //   return true;
                          // },
                        })}
                      />
                    </Form.Group>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col className="main-form-section my-3">
                <Form.Label>Image Preview</Form.Label>

                {imagePreview && (
                  <div className="image-preview-container">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{ width: "120px", height: "100px" }}
                    />
                  </div>
                )}

                {imageFile instanceof FileList && imageFile.length > 0 && (
                  <div className="image-preview-container">
                    <img
                      src={URL.createObjectURL(imageFile[0])}
                      alt="Preview"
                      style={{ width: "120px", height: "100px" }}
                    />
                  </div>
                )}
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Label>Products</Form.Label>

                  <Controller
                    name="product_ids"
                    control={control}
                    rules={{ required: "Select at least one product" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={products}
                        isMulti
                        placeholder="Select Products"
                      />
                    )}
                  />

                  {errors.product_ids && (
                    <span className="text-danger">
                      {errors.product_ids.message}
                    </span>
                  )}
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
